import React , {createContext , useState , useContext, Children} from "react";

const recommendationEngineContext = createContext();


export const useRecommendationEngineAuth = () => {
    return useContext(recommendationEngineContext);
}

export const RecommendationEngineAuthProvider = ({children}) => {
    const isAuth = !localStorage.getItem('recommendationenginetoken');

    const [isRecomEngineAuthenticated , setISRecomEngineAuthenticated] = useState(!isAuth);

    const recomengineLogin = () => {
        setISRecomEngineAuthenticated(true);
    }

    const recomengineLogout = () => {
        setISRecomEngineAuthenticated(false);
    }

    return (
        <recommendationEngineContext.Provider value ={{isRecomEngineAuthenticated , recomengineLogin ,recomengineLogout}}>
            {children}
        </recommendationEngineContext.Provider>
    )
}